"use strict";
"use client";

var _toConsumableArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _classCallCheck = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass.js").default;

var _possibleConstructorReturn = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js").default;

var _inherits = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits.js").default;

var _get = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get.js").default;

var _getPrototypeOf = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf.js").default;

var _wrapNativeSuper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper.js").default;

var _classPrivateFieldGet = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classPrivateFieldGet.js").default;

var _classPrivateFieldSet = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classPrivateFieldSet.js").default;

var _defineProperty = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _objectSpread = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _objectWithoutProperties = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _slicedToArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _createForOfIteratorHelper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _keys;

var _excluded = ["scope", "children"],
    _excluded2 = ["state"],
    _excluded3 = ["scope", "children"];

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps( // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var index_exports = {};

__export(index_exports, {
  createCollection: function createCollection() {
    return _createCollection;
  },
  unstable_createCollection: function unstable_createCollection() {
    return createCollection2;
  }
});

module.exports = __toCommonJS(index_exports); // src/collection-legacy.tsx

var import_react = __toESM(require("react"));

var import_react_context = require("@radix-ui/react-context");

var import_react_compose_refs = require("@radix-ui/react-compose-refs");

var import_react_slot = require("@radix-ui/react-slot");

var import_jsx_runtime = require("react/jsx-runtime");

function _createCollection(name) {
  var PROVIDER_NAME = name + "CollectionProvider";

  var _ref = (0, import_react_context.createContextScope)(PROVIDER_NAME),
      _ref2 = _slicedToArray(_ref, 2),
      createCollectionContext = _ref2[0],
      createCollectionScope = _ref2[1];

  var _createCollectionCont = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */new Map()
  }),
      _createCollectionCont2 = _slicedToArray(_createCollectionCont, 2),
      CollectionProviderImpl = _createCollectionCont2[0],
      useCollectionContext = _createCollectionCont2[1];

  var CollectionProvider = function CollectionProvider(props) {
    var scope = props.scope,
        children = props.children;
    var ref = import_react.default.useRef(null);
    var itemMap = import_react.default.useRef( /* @__PURE__ */new Map()).current;
    return /* @__PURE__ */(0, import_jsx_runtime.jsx)(CollectionProviderImpl, {
      scope: scope,
      itemMap: itemMap,
      collectionRef: ref,
      children: children
    });
  };

  CollectionProvider.displayName = PROVIDER_NAME;
  var COLLECTION_SLOT_NAME = name + "CollectionSlot";
  var CollectionSlotImpl = (0, import_react_slot.createSlot)(COLLECTION_SLOT_NAME);
  var CollectionSlot = import_react.default.forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
        children = props.children;
    var context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    var composedRefs = (0, import_react_compose_refs.useComposedRefs)(forwardedRef, context.collectionRef);
    return /* @__PURE__ */(0, import_jsx_runtime.jsx)(CollectionSlotImpl, {
      ref: composedRefs,
      children: children
    });
  });
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  var ITEM_SLOT_NAME = name + "CollectionItemSlot";
  var ITEM_DATA_ATTR = "data-radix-collection-item";
  var CollectionItemSlotImpl = (0, import_react_slot.createSlot)(ITEM_SLOT_NAME);
  var CollectionItemSlot = import_react.default.forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
        children = props.children,
        itemData = _objectWithoutProperties(props, _excluded);

    var ref = import_react.default.useRef(null);
    var composedRefs = (0, import_react_compose_refs.useComposedRefs)(forwardedRef, ref);
    var context = useCollectionContext(ITEM_SLOT_NAME, scope);
    import_react.default.useEffect(function () {
      context.itemMap.set(ref, _objectSpread({
        ref: ref
      }, itemData));
      return function () {
        return void context.itemMap.delete(ref);
      };
    });
    return /* @__PURE__ */(0, import_jsx_runtime.jsx)(CollectionItemSlotImpl, _objectSpread(_objectSpread({}, _defineProperty({}, ITEM_DATA_ATTR, "")), {}, {
      ref: composedRefs,
      children: children
    }));
  });
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;

  function useCollection(scope) {
    var context = useCollectionContext(name + "CollectionConsumer", scope);
    var getItems = import_react.default.useCallback(function () {
      var collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      var orderedNodes = Array.from(collectionNode.querySelectorAll("[".concat(ITEM_DATA_ATTR, "]")));
      var items = Array.from(context.itemMap.values());
      var orderedItems = items.sort(function (a, b) {
        return orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current);
      });
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }

  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection, createCollectionScope];
} // src/collection.tsx


var import_react2 = __toESM(require("react"));

var import_react_context2 = require("@radix-ui/react-context");

var import_react_compose_refs2 = require("@radix-ui/react-compose-refs");

var import_react_slot2 = require("@radix-ui/react-slot"); // src/ordered-dictionary.ts


var __instanciated = /* @__PURE__ */new WeakMap();

var OrderedDict = (_keys = /*#__PURE__*/new WeakMap(), /*#__PURE__*/function (_Map) {
  function _OrderedDict(entries) {
    var _this2;

    _classCallCheck(this, _OrderedDict);

    _this2 = _callSuper(this, _OrderedDict, [entries]);

    _keys.set(_this2, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(_this2, _keys, _toConsumableArray(_get((_this2, _getPrototypeOf(_OrderedDict.prototype)), "keys", _this2).call(_this2)));

    __instanciated.set(_this2, true);

    return _this2;
  }

  _inherits(_OrderedDict, _Map);

  return _createClass(_OrderedDict, [{
    key: "set",
    value: function set(key, value) {
      if (__instanciated.get(this)) {
        if (this.has(key)) {
          _classPrivateFieldGet(this, _keys)[_classPrivateFieldGet(this, _keys).indexOf(key)] = key;
        } else {
          _classPrivateFieldGet(this, _keys).push(key);
        }
      }

      _get(_getPrototypeOf(_OrderedDict.prototype), "set", this).call(this, key, value);

      return this;
    }
  }, {
    key: "insert",
    value: function insert(index, key, value) {
      var has = this.has(key);

      var length = _classPrivateFieldGet(this, _keys).length;

      var relativeIndex = toSafeInteger(index);
      var actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
      var safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;

      if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
        this.set(key, value);
        return this;
      }

      var size = this.size + (has ? 0 : 1);

      if (relativeIndex < 0) {
        actualIndex++;
      }

      var keys = _toConsumableArray(_classPrivateFieldGet(this, _keys));

      var nextValue;
      var shouldSkip = false;

      for (var i = actualIndex; i < size; i++) {
        if (actualIndex === i) {
          var nextKey = keys[i];

          if (keys[i] === key) {
            nextKey = keys[i + 1];
          }

          if (has) {
            this.delete(key);
          }

          nextValue = this.get(nextKey);
          this.set(key, value);
        } else {
          if (!shouldSkip && keys[i - 1] === key) {
            shouldSkip = true;
          }

          var currentKey = keys[shouldSkip ? i : i - 1];
          var currentValue = nextValue;
          nextValue = this.get(currentKey);
          this.delete(currentKey);
          this.set(currentKey, currentValue);
        }
      }

      return this;
    }
  }, {
    key: "with",
    value: function _with(index, key, value) {
      var copy = new _OrderedDict(this);
      copy.insert(index, key, value);
      return copy;
    }
  }, {
    key: "before",
    value: function before(key) {
      var index = _classPrivateFieldGet(this, _keys).indexOf(key) - 1;

      if (index < 0) {
        return void 0;
      }

      return this.entryAt(index);
    }
    /**
     * Sets a new key-value pair at the position before the given key.
     */

  }, {
    key: "setBefore",
    value: function setBefore(key, newKey, value) {
      var index = _classPrivateFieldGet(this, _keys).indexOf(key);

      if (index === -1) {
        return this;
      }

      return this.insert(index, newKey, value);
    }
  }, {
    key: "after",
    value: function after(key) {
      var index = _classPrivateFieldGet(this, _keys).indexOf(key);

      index = index === -1 || index === this.size - 1 ? -1 : index + 1;

      if (index === -1) {
        return void 0;
      }

      return this.entryAt(index);
    }
    /**
     * Sets a new key-value pair at the position after the given key.
     */

  }, {
    key: "setAfter",
    value: function setAfter(key, newKey, value) {
      var index = _classPrivateFieldGet(this, _keys).indexOf(key);

      if (index === -1) {
        return this;
      }

      return this.insert(index + 1, newKey, value);
    }
  }, {
    key: "first",
    value: function first() {
      return this.entryAt(0);
    }
  }, {
    key: "last",
    value: function last() {
      return this.entryAt(-1);
    }
  }, {
    key: "clear",
    value: function clear() {
      _classPrivateFieldSet(this, _keys, []);

      return _get(_getPrototypeOf(_OrderedDict.prototype), "clear", this).call(this);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var deleted = _get(_getPrototypeOf(_OrderedDict.prototype), "delete", this).call(this, key);

      if (deleted) {
        _classPrivateFieldGet(this, _keys).splice(_classPrivateFieldGet(this, _keys).indexOf(key), 1);
      }

      return deleted;
    }
  }, {
    key: "deleteAt",
    value: function deleteAt(index) {
      var key = this.keyAt(index);

      if (key !== void 0) {
        return this.delete(key);
      }

      return false;
    }
  }, {
    key: "at",
    value: function at(index) {
      var key = _at(_classPrivateFieldGet(this, _keys), index);

      if (key !== void 0) {
        return this.get(key);
      }
    }
  }, {
    key: "entryAt",
    value: function entryAt(index) {
      var key = _at(_classPrivateFieldGet(this, _keys), index);

      if (key !== void 0) {
        return [key, this.get(key)];
      }
    }
  }, {
    key: "indexOf",
    value: function indexOf(key) {
      return _classPrivateFieldGet(this, _keys).indexOf(key);
    }
  }, {
    key: "keyAt",
    value: function keyAt(index) {
      return _at(_classPrivateFieldGet(this, _keys), index);
    }
  }, {
    key: "from",
    value: function from(key, offset) {
      var index = this.indexOf(key);

      if (index === -1) {
        return void 0;
      }

      var dest = index + offset;
      if (dest < 0) dest = 0;
      if (dest >= this.size) dest = this.size - 1;
      return this.at(dest);
    }
  }, {
    key: "keyFrom",
    value: function keyFrom(key, offset) {
      var index = this.indexOf(key);

      if (index === -1) {
        return void 0;
      }

      var dest = index + offset;
      if (dest < 0) dest = 0;
      if (dest >= this.size) dest = this.size - 1;
      return this.keyAt(dest);
    }
  }, {
    key: "find",
    value: function find(predicate, thisArg) {
      var index = 0;

      var _iterator2 = _createForOfIteratorHelper(this),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var entry = _step2.value;

          if (Reflect.apply(predicate, thisArg, [entry, index, this])) {
            return entry;
          }

          index++;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return void 0;
    }
  }, {
    key: "findIndex",
    value: function findIndex(predicate, thisArg) {
      var index = 0;

      var _iterator3 = _createForOfIteratorHelper(this),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var entry = _step3.value;

          if (Reflect.apply(predicate, thisArg, [entry, index, this])) {
            return index;
          }

          index++;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return -1;
    }
  }, {
    key: "filter",
    value: function filter(predicate, thisArg) {
      var entries = [];
      var index = 0;

      var _iterator4 = _createForOfIteratorHelper(this),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var entry = _step4.value;

          if (Reflect.apply(predicate, thisArg, [entry, index, this])) {
            entries.push(entry);
          }

          index++;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return new _OrderedDict(entries);
    }
  }, {
    key: "map",
    value: function map(callbackfn, thisArg) {
      var entries = [];
      var index = 0;

      var _iterator5 = _createForOfIteratorHelper(this),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var entry = _step5.value;
          entries.push([entry[0], Reflect.apply(callbackfn, thisArg, [entry, index, this])]);
          index++;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return new _OrderedDict(entries);
    }
  }, {
    key: "reduce",
    value: function reduce() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var callbackfn = args[0],
          initialValue = args[1];
      var index = 0;
      var accumulator = initialValue !== null && initialValue !== void 0 ? initialValue : this.at(0);

      var _iterator6 = _createForOfIteratorHelper(this),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var entry = _step6.value;

          if (index === 0 && args.length === 1) {
            accumulator = entry;
          } else {
            accumulator = Reflect.apply(callbackfn, this, [accumulator, entry, index, this]);
          }

          index++;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return accumulator;
    }
  }, {
    key: "reduceRight",
    value: function reduceRight() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var callbackfn = args[0],
          initialValue = args[1];
      var accumulator = initialValue !== null && initialValue !== void 0 ? initialValue : this.at(-1);

      for (var index = this.size - 1; index >= 0; index--) {
        var entry = this.at(index);

        if (index === this.size - 1 && args.length === 1) {
          accumulator = entry;
        } else {
          accumulator = Reflect.apply(callbackfn, this, [accumulator, entry, index, this]);
        }
      }

      return accumulator;
    }
  }, {
    key: "toSorted",
    value: function toSorted(compareFn) {
      var entries = _toConsumableArray(this.entries()).sort(compareFn);

      return new _OrderedDict(entries);
    }
  }, {
    key: "toReversed",
    value: function toReversed() {
      var reversed = new _OrderedDict();

      for (var index = this.size - 1; index >= 0; index--) {
        var key = this.keyAt(index);
        var element = this.get(key);
        reversed.set(key, element);
      }

      return reversed;
    }
  }, {
    key: "toSpliced",
    value: function toSpliced() {
      var entries = _toConsumableArray(this.entries());

      entries.splice.apply(entries, arguments);
      return new _OrderedDict(entries);
    }
  }, {
    key: "slice",
    value: function slice(start, end) {
      var result = new _OrderedDict();
      var stop = this.size - 1;

      if (start === void 0) {
        return result;
      }

      if (start < 0) {
        start = start + this.size;
      }

      if (end !== void 0 && end > 0) {
        stop = end - 1;
      }

      for (var index = start; index <= stop; index++) {
        var key = this.keyAt(index);
        var element = this.get(key);
        result.set(key, element);
      }

      return result;
    }
  }, {
    key: "every",
    value: function every(predicate, thisArg) {
      var index = 0;

      var _iterator7 = _createForOfIteratorHelper(this),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var entry = _step7.value;

          if (!Reflect.apply(predicate, thisArg, [entry, index, this])) {
            return false;
          }

          index++;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return true;
    }
  }, {
    key: "some",
    value: function some(predicate, thisArg) {
      var index = 0;

      var _iterator8 = _createForOfIteratorHelper(this),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var entry = _step8.value;

          if (Reflect.apply(predicate, thisArg, [entry, index, this])) {
            return true;
          }

          index++;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      return false;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(Map)));

function _at(array, index) {
  if ("at" in Array.prototype) {
    return Array.prototype.at.call(array, index);
  }

  var actualIndex = toSafeIndex(array, index);
  return actualIndex === -1 ? void 0 : array[actualIndex];
}

function toSafeIndex(array, index) {
  var length = array.length;
  var relativeIndex = toSafeInteger(index);
  var actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
  return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}

function toSafeInteger(number) {
  return number !== number || number === 0 ? 0 : Math.trunc(number);
} // src/collection.tsx


var import_jsx_runtime2 = require("react/jsx-runtime");

function createCollection2(name) {
  var PROVIDER_NAME = name + "CollectionProvider";

  var _ref3 = (0, import_react_context2.createContextScope)(PROVIDER_NAME),
      _ref4 = _slicedToArray(_ref3, 2),
      createCollectionContext = _ref4[0],
      createCollectionScope = _ref4[1];

  var _createCollectionCont3 = createCollectionContext(PROVIDER_NAME, {
    collectionElement: null,
    collectionRef: {
      current: null
    },
    collectionRefObject: {
      current: null
    },
    itemMap: new OrderedDict(),
    setItemMap: function setItemMap() {
      return void 0;
    }
  }),
      _createCollectionCont4 = _slicedToArray(_createCollectionCont3, 2),
      CollectionContextProvider = _createCollectionCont4[0],
      useCollectionContext = _createCollectionCont4[1];

  var CollectionProvider = function CollectionProvider(_ref5) {
    var state = _ref5.state,
        props = _objectWithoutProperties(_ref5, _excluded2);

    return state ? /* @__PURE__ */(0, import_jsx_runtime2.jsx)(CollectionProviderImpl, _objectSpread(_objectSpread({}, props), {}, {
      state: state
    })) : /* @__PURE__ */(0, import_jsx_runtime2.jsx)(CollectionInit, _objectSpread({}, props));
  };

  CollectionProvider.displayName = PROVIDER_NAME;

  var CollectionInit = function CollectionInit(props) {
    var state = useInitCollection();
    return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(CollectionProviderImpl, _objectSpread(_objectSpread({}, props), {}, {
      state: state
    }));
  };

  CollectionInit.displayName = PROVIDER_NAME + "Init";

  var CollectionProviderImpl = function CollectionProviderImpl(props) {
    var scope = props.scope,
        children = props.children,
        state = props.state;
    var ref = import_react2.default.useRef(null);

    var _import_react2$defaul = import_react2.default.useState(null),
        _import_react2$defaul2 = _slicedToArray(_import_react2$defaul, 2),
        collectionElement = _import_react2$defaul2[0],
        setCollectionElement = _import_react2$defaul2[1];

    var composeRefs = (0, import_react_compose_refs2.useComposedRefs)(ref, setCollectionElement);

    var _state = _slicedToArray(state, 2),
        itemMap = _state[0],
        setItemMap = _state[1];

    import_react2.default.useEffect(function () {
      if (!collectionElement) return;
      var observer = getChildListObserver(function () {});
      observer.observe(collectionElement, {
        childList: true,
        subtree: true
      });
      return function () {
        observer.disconnect();
      };
    }, [collectionElement]);
    return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(CollectionContextProvider, {
      scope: scope,
      itemMap: itemMap,
      setItemMap: setItemMap,
      collectionRef: composeRefs,
      collectionRefObject: ref,
      collectionElement: collectionElement,
      children: children
    });
  };

  CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
  var COLLECTION_SLOT_NAME = name + "CollectionSlot";
  var CollectionSlotImpl = (0, import_react_slot2.createSlot)(COLLECTION_SLOT_NAME);
  var CollectionSlot = import_react2.default.forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
        children = props.children;
    var context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    var composedRefs = (0, import_react_compose_refs2.useComposedRefs)(forwardedRef, context.collectionRef);
    return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(CollectionSlotImpl, {
      ref: composedRefs,
      children: children
    });
  });
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  var ITEM_SLOT_NAME = name + "CollectionItemSlot";
  var ITEM_DATA_ATTR = "data-radix-collection-item";
  var CollectionItemSlotImpl = (0, import_react_slot2.createSlot)(ITEM_SLOT_NAME);
  var CollectionItemSlot = import_react2.default.forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
        children = props.children,
        itemData = _objectWithoutProperties(props, _excluded3);

    var ref = import_react2.default.useRef(null);

    var _import_react2$defaul3 = import_react2.default.useState(null),
        _import_react2$defaul4 = _slicedToArray(_import_react2$defaul3, 2),
        element = _import_react2$defaul4[0],
        setElement = _import_react2$defaul4[1];

    var composedRefs = (0, import_react_compose_refs2.useComposedRefs)(forwardedRef, ref, setElement);
    var context = useCollectionContext(ITEM_SLOT_NAME, scope);
    var setItemMap = context.setItemMap;
    var itemDataRef = import_react2.default.useRef(itemData);

    if (!shallowEqual(itemDataRef.current, itemData)) {
      itemDataRef.current = itemData;
    }

    var memoizedItemData = itemDataRef.current;
    import_react2.default.useEffect(function () {
      var itemData2 = memoizedItemData;
      setItemMap(function (map) {
        if (!element) {
          return map;
        }

        if (!map.has(element)) {
          map.set(element, _objectSpread(_objectSpread({}, itemData2), {}, {
            element: element
          }));
          return map.toSorted(sortByDocumentPosition);
        }

        return map.set(element, _objectSpread(_objectSpread({}, itemData2), {}, {
          element: element
        })).toSorted(sortByDocumentPosition);
      });
      return function () {
        setItemMap(function (map) {
          if (!element || !map.has(element)) {
            return map;
          }

          map.delete(element);
          return new OrderedDict(map);
        });
      };
    }, [element, memoizedItemData, setItemMap]);
    return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(CollectionItemSlotImpl, _objectSpread(_objectSpread({}, _defineProperty({}, ITEM_DATA_ATTR, "")), {}, {
      ref: composedRefs,
      children: children
    }));
  });
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;

  function useInitCollection() {
    return import_react2.default.useState(new OrderedDict());
  }

  function useCollection(scope) {
    var _useCollectionContext = useCollectionContext(name + "CollectionConsumer", scope),
        itemMap = _useCollectionContext.itemMap;

    return itemMap;
  }

  var functions = {
    createCollectionScope: createCollectionScope,
    useCollection: useCollection,
    useInitCollection: useInitCollection
  };
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, functions];
}

function shallowEqual(a, b) {
  if (a === b) return true;
  if (typeof a !== "object" || typeof b !== "object") return false;
  if (a == null || b == null) return false;
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;

  for (var _i = 0, _keysA = keysA; _i < _keysA.length; _i++) {
    var key = _keysA[_i];
    if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
    if (a[key] !== b[key]) return false;
  }

  return true;
}

function isElementPreceding(a, b) {
  return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}

function sortByDocumentPosition(a, b) {
  return !a[1].element || !b[1].element ? 0 : isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}

function getChildListObserver(callback) {
  var observer = new MutationObserver(function (mutationsList) {
    var _iterator9 = _createForOfIteratorHelper(mutationsList),
        _step9;

    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var mutation = _step9.value;

        if (mutation.type === "childList") {
          callback();
          return;
        }
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  });
  return observer;
}